<div class="white_round">
    <div *ngFor='let iDescription of eventDescription.eventDescriptions; let i = index' class="cpee_container" (click)="openEventForEditing(iDescription)">
        <div class="cpee_name">{{iDescription.default_name}}</div>
        <div class="cpee_reaction">{{eventDescription.reactionTexts[i]}}</div>
        <div class="cpee_status">{{iDescription.active === 1 ? trans('general.enabled') : trans('general.disabled')}}</div>
        <div class="cpee_cid"><span>{{iDescription.qualifier}}-{{iDescription.event_code}}</span></div>
        <div class="cpee_arrow"><svg viewBox="0 0 8.402 14.697"><path d="M13.783,13.54l5.561-5.557A1.05,1.05,0,1,0,17.857,6.5l-6.3,6.3a1.048,1.048,0,0,0-.031,1.448l6.327,6.34A1.05,1.05,0,0,0,19.34,19.1Z" transform="translate(19.653 20.891) rotate(180)"/></svg></div>
    </div>
</div>
